var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// url, ua, ip, user_id, active_timestamp
export function collectActivityStream(userInfo, event, data, analyticsURI) {
    return __awaiter(this, void 0, void 0, function* () {
        const env = yield getEnvDiagnostics();
        try {
            yield fetch(analyticsURI, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    payload: Object.assign({ event, user: userInfo, ua: navigator.userAgent, ip: "127.0.0.1", active_timestamp: Date.now(), env }, data),
                }),
            });
        }
        catch (err) {
            console.error(`Collect activity stream failed, reason:(${err.message})`);
        }
    });
}
const getEnvDiagnostics = () => __awaiter(void 0, void 0, void 0, function* () {
    const ua = navigator.userAgent || "";
    return {
        is_iframe: window.top !== window,
        ls_state: getLocalStorageState(),
        sandbox: getSandboxFlags(),
        hasStorageAccess: yield hasStorageAccess(),
        visibility: document.visibilityState,
        prerender: detectPrerender(),
        in_app: isInAppBrowser(ua),
        site: getTopSiteHost(),
        ua,
    };
});
/** 更細的 localStorage 狀態（ok / blocked / errorName） */
const getLocalStorageState = () => {
    try {
        const x = "__ls_probe__";
        window.localStorage.setItem(x, x);
        window.localStorage.removeItem(x);
        return "ok";
    }
    catch (e) {
        // 常見：SecurityError, QuotaExceededError
        return (e && (e.name || e.message)) || "blocked";
    }
};
/** 取得 sandbox 標記（若無則回 "none"） */
const getSandboxFlags = () => {
    try {
        // 在部分環境 frameElement 可能存取會拋錯，包 try/catch
        // @ts-ignore
        const fe = window.frameElement;
        if (fe && fe.sandbox) {
            const tokens = [];
            // DOMTokenList 可展開
            fe.sandbox.forEach
                ? fe.sandbox.forEach((t) => tokens.push(t))
                : tokens.push(String(fe.sandbox));
            return tokens.join(",");
        }
        return "none";
    }
    catch (_a) {
        return "unknown";
    }
};
/** 嘗試偵測 Storage Access（僅部分瀏覽器支援） */
const hasStorageAccess = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // @ts-ignore
        if (typeof document.hasStorageAccess === "function") {
            // @ts-ignore
            const result = yield document.hasStorageAccess();
            return result ? "granted" : "denied";
        }
        return "na";
    }
    catch (_a) {
        return "na";
    }
});
export const detectPrerender = () => {
    try {
        const d = document;
        // 1) 現代 Chromium：document.prerendering 是 boolean
        if (typeof d.prerendering === "boolean") {
            return d.prerendering === true;
        }
        // 2) 保守退路：有些實作早期把 visibilityState 設成 "prerender"
        //    用 any 取出字串再比較，避免 TS union 報錯
        const vs = document.visibilityState;
        if (typeof vs === "string" && vs.toLowerCase() === "prerender") {
            return true;
        }
        // 3) 其他情況視為非 prerender
        return false;
    }
    catch (_a) {
        return false;
    }
};
/** 取得頂層站點（iframe 下優先 referrer） */
const getTopSiteHost = () => {
    try {
        const ref = document.referrer;
        if (ref) {
            return new URL(ref).host;
        }
        return new URL(location.href).host;
    }
    catch (_a) {
        return "unknown";
    }
};
/** 是否在內嵌瀏覽器（Line/FB/IG 等） */
const isInAppBrowser = (ua) => {
    return / Line\/|FBAV|FBAN|Instagram|Messenger/i.test(ua);
};
//# sourceMappingURL=collect.utils.js.map